import { AuthAction, AuthState, SET_USER, SET_PLAYLIST, SET_TOKEN, SET_LOADING, SIGN_OUT, SET_ERROR, NEED_VERIFICATION, SET_SUCCESS, CREATE_ANON } from '../../constants/authConstants';

const initialState: AuthState = {
    user: null,
    playList: [],
    authenticated: false,
    loading: false,
    error: '',
    needVerification: false,
    success: '',
    anonymous: false,
    token: ''
};

export default (state = initialState, action: AuthAction) => {
    switch(action.type) {
        case SET_USER:
            return {
                ...state,
                user: action.payload,
                authenticated: true
            };
        case SET_PLAYLIST:
            return {
                ...state,
                playlist: action.payload
            };
        case SET_TOKEN:
            return {
                ...state,
                token: action.payload
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case SIGN_OUT:
            return {
                ...state,
                user: null,
                authenticated: false,
                loading: false
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case NEED_VERIFICATION:
            return {
                ...state,
                needVerification: true
            };
        case SET_SUCCESS:
            return {
                ...state,
                success: action.payload
            };
        case CREATE_ANON:
            return {
                ...state,
                user: action.payload,
                anonymous: true
            };
        default:
            return state;
    }
}
